<template>
  <v-app data-club-info-modal-component>
    <component
      :is="clubInfoModal"
      :show-info-club-service-price="showClubServicePriceInfo"
      :title="modalTitle"
    >
      <img
        class="d-block mx-auto"
        src="/static/_v1/pd/pictures/ui-kit/club.svg"
        alt="Картинка Клуба"
        width="150"
        height="150"
        :class="isMobile ? 'mb-8' : 'mb-4'"
      >
      <ClubInfoModalContent
        :club-info-list="clubInfoList"
        :use-list-element="showClubServicePriceInfo"
      />
      <ClubInfoModalExpansionPanels
        v-if="!showClubServicePriceInfo"
        class="mt-8"
      />
    </component>
  </v-app>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import { emitOpenCardInfo } from 'www/global.js.blocks/common/club-card-info/functions'
import ClubInfoModalDesktop from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/desktop/ClubInfoModal.vue'
import ClubInfoModalMobile from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/mobile/ClubInfoModal.vue'
import ClubInfoModalExpansionPanels
  from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/common/ClubInfoModalExpansionPanels.vue'
import ClubInfoModalContent
  from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/common/ClubInfoModalContent.vue'

import {
  CLUB_CARD_INFO,
  CLUB_SERVICE_PRICE_INFO,
} from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/constants'

export default {
  name: 'ClubInfoModal',
  vuetify,
  components: {
    ClubInfoModalExpansionPanels,
    ClubInfoModalContent,
  },
  props: {
    showClubServicePriceInfo: {
      type: Boolean,
      default: false,
    },
    userPhone: {
      type: String,
      default: window.USER.userPhone,
    },
    userClubData: {
      type: Object,
      default: () => ({ ...window.USER.club }),
    },
  },
  data: () => ({
    isMobile: window.MOBILE_VERSION,
    discountOnServices: window.USER.club.discountOnServices,
  }),
  computed: {
    clubInfoModal() {
      return this.isMobile ? ClubInfoModalMobile : ClubInfoModalDesktop
    },
    clubInfoList() {
      return this.showClubServicePriceInfo ? CLUB_SERVICE_PRICE_INFO : CLUB_CARD_INFO
    },
    modalTitle() {
      return this.showClubServicePriceInfo ? `Клубная цена -${this.discountOnServices}% на услуги` : 'Клубная карта ПроДокторов'
    },
  },
  created() {
    document.addEventListener('click', this.handleClickDocument)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickDocument)
  },
  methods: {
    handleClickDocument({ target }) {
      if (target.hasAttribute('data-open-club-card')) {
        if (this.userClubData.isInClub) {
          emitOpenCardInfo(this.userClubData, this.userPhone)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-club-info-modal-component] {
  @include v-app-reset;
}
</style>
